import { render, staticRenderFns } from "./GlobalContactPage.vue?vue&type=template&id=a7ae088a&scoped=true"
import script from "./GlobalContactPage.vue?vue&type=script&lang=js"
export * from "./GlobalContactPage.vue?vue&type=script&lang=js"
import style0 from "./GlobalContactPage.vue?vue&type=style&index=0&id=a7ae088a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ae088a",
  null
  
)

export default component.exports